import { render, staticRenderFns } from "./DashboardContextHeader.vue?vue&type=template&id=5fb470dc&scoped=true&"
import script from "./DashboardContextHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardContextHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContextHeader.vue?vue&type=style&index=0&id=5fb470dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb470dc",
  null
  
)

export default component.exports